"use client"

import { StatusPublish, VisibilityPublish } from "@/(admin)/modules/post/pages/StatusPublish"
import { t } from "@/languages/i18n"
import { CaretDownOutlined, CaretUpOutlined, DownloadOutlined } from "@ant-design/icons"
import { Button, Space, Typography } from "antd"
import React, { useState } from "react"

const { Title } = Typography

interface CampaignPublishProps {
  onSubmit: () => void
  isCreateEdit: boolean
  status: string
  setStatus: (status: string) => void
  loading?: boolean
  exporting?: boolean
  onCancel?: () => void
  onExportCsv?: () => void
}

const CampaignPublish: React.FC<CampaignPublishProps> = ({
  onSubmit,
  isCreateEdit,
  status,
  setStatus,
  loading = false,
  exporting = false,
  onCancel,
  onExportCsv,
}) => {
  const [isPublishListVisible, setPublishListVisible] = useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0">
          {t("Xuất bản")}
        </Title>
        <Button
          onClick={() => setPublishListVisible(!isPublishListVisible)}
          className="flex items-center"
          icon={isPublishListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isPublishListVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4">
            <StatusPublish setStatus={setStatus} status={status} />
            <VisibilityPublish status={status} />
          </Space>
          <div className="flex flex-col gap-2 border-t bg-[#f6f7f7] rounded-b-[10px] px-4 py-3">
            <div className="flex gap-2">
              <Button
                type="primary"
                onClick={onSubmit}
                loading={loading}
              >
                {status === "Draft" ? t("Lưu bản nháp") : isCreateEdit ? t("Xuất bản") : t("Cập nhật")}
              </Button>
              {onCancel && (
                <Button onClick={onCancel}>
                  {t("Huỷ")}
                </Button>
              )}
            </div>
            {onExportCsv && (
              <Button icon={<DownloadOutlined />} onClick={onExportCsv} loading={exporting} className="w-full">
                Export CSV
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default CampaignPublish
